import { ConvertDateToJalali } from "utils/ConvertDateToJalali";

export const DateSelectorFunction = (
  setValue,
  Date,
  IsRange,
  IsFromDate,
  SetOutput
) => {
  setValue(Date);
  if (IsRange) {
    if (IsFromDate) {
      SetOutput &&
        SetOutput((prev) => ({
          ...prev,
          fromDate: ConvertDateToJalali(Date),
        }));
    } else {
      SetOutput &&
        SetOutput((prev) => ({
          ...prev,
          toDate: ConvertDateToJalali(Date),
        }));
    }
  } else {
    SetOutput && SetOutput(ConvertDateToJalali(Date));
  }
};
